import React from "react";
import { useGetPartHistory } from "../../hooks";
import {
  HubTableTemplate,
  TableSkeleton,
  UserDetailIcon,
} from "../../components";
import PartHistoryEmpty from "./PartHistoryEmpty";
import { stringToAlphabetSum } from "../../helpers/userImageColor";
import { PartHistoryContextMenu } from "./PartHistoryContextMenu";

const items = [
  {
    id: "partNumber",
    label: "Part Number",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "lastSentPrice",
    label: "Price",
  },
  {
    id: "weight",
    label: "Weight",
  },
  {
    id: "user",
    label: "Updated By",
  },
  {
    id: "createdAt",
    label: "Updated At",
  },
];

const keys = [
  {
    value: "partNumber",
  },
  {
    value: "partName",
  },
  {
    value: "lastSentPrice",
    isCurrency: true,
    defaultValue: 0,
  },
  {
    value: "weight",
  },
  {
    value: "user.name",
    CustomComponent: ({ item }) => {
      const user = {
        name: item.user.name,
        hueShift: stringToAlphabetSum(item.user.name),
      };
      return <UserDetailIcon size={16} user={user} variant="rounded" />;
    },
  },
  {
    value: "createdAt",
    isDateTime: true,
  },
];

export const PartHistoryTable = ({ id }) => {
  const { data, isLoading } = useGetPartHistory(id);

  const headerProps = { items, includeEnd: true };
  const bodyProps = {
    items: data?.rows,
    keys,
    ContextMenu: PartHistoryContextMenu,
    ContextMenuProps: { id },
  };
  const props = { headerProps, bodyProps, meta: data?.meta };

  if (isLoading) return <TableSkeleton />;
  return data?.rows?.length ? (
    <HubTableTemplate id="PartsHistoryTable" {...props} />
  ) : (
    <PartHistoryEmpty />
  );
};

export default PartHistoryTable;
